import { createContext, useContext, useSyncExternalStore } from "react";

import { type GameSnapshot, GameStore } from "src/engine/game/GameStore";

export const GameStoreContext = createContext<GameStore | null>(null);

export function useStore(): GameStore {
  const store = useContext(GameStoreContext);
  if (!store) throw new Error("useStore outside GameStoreContext");
  return store;
}

/**
 * The one bridge between the store and React. The snapshot object is replaced
 * wholesale on every dispatch, so reference equality is a correct change test.
 */
export function useGameSnapshot(): GameSnapshot {
  const store = useStore();
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
